import { handleActions } from 'redux-actions';
import { logoutSuccess } from 'ducks/auth/actions';
import {
  createIncidentReportSuccess,
  incidentReportsSuccess,
  incidentReportSuccess,
  incidentReportLinkSuccess,
  pendingIncidentReportSuccess,
  approveIncidentReportSuccess,
} from './actions';
import initialState from './states';
import { IR_STATUSES } from 'app/types/constants';

export default handleActions(
  {
    [logoutSuccess]() {
      return {
        ...initialState,
      };
    },
    [incidentReportsSuccess](state, { payload }) {
      return {
        ...state,
        info: payload.reduce((res, item) => {
          res[item.reportId] = item;
          return res;
        }, {}),
      };
    },

    [incidentReportSuccess](state, { payload }) {
      return {
        ...state,
        info: {
          ...state.info,
          [payload.reportID]: payload,
        },
      };
    },
    [createIncidentReportSuccess](state, { payload }) {
      return {
        ...state,
        info: {
          ...state.info,
          [payload.reportID]: payload,
        },
      };
    },
    [incidentReportLinkSuccess](state, { payload }) {
      return {
        ...state,
        reportLinks: {
          ...state.reportLinks,
          [payload.reportId]: payload.link,
        },
      };
    },
    [pendingIncidentReportSuccess](state, { payload: { reportID, pendingReason } }) {
      if (!reportID) {
        return state;
      }

      return {
        ...state,
        info: {
          ...state.info,
          [reportID]: {
            ...state.info[reportID],
            status: IR_STATUSES.PENDING,
            pendingReason: pendingReason,
          },
        },
      };
    },
    [approveIncidentReportSuccess](state, { payload: { reportID } }) {
      if (!reportID) {
        return state;
      }

      return {
        ...state,
        info: {
          ...state.info,
          [reportID]: {
            ...state.info[reportID],
            status: IR_STATUSES.APPROVED,
          },
        },
      };
    },
  },
  initialState
);
